const escapeHtml = (value: string) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')

export const renderMaintenanceInline = (value: string) => {
  const escaped = escapeHtml(value)
  return escaped
    .replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>')
    .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
    .replace(/(^|[\s(])\*([^*\n]+)\*/g, '$1<em>$2</em>')
}

export const renderMaintenanceMarkdown = (value: string) => {
  const lines = String(value ?? '').replace(/\r\n/g, '\n').split('\n')
  const html: string[] = []
  let list: 'ul' | 'ol' | null = null
  const closeList = () => {
    if (!list) return
    html.push(`</${list}>`)
    list = null
  }

  lines.forEach((line) => {
    const bullet = line.match(/^\s*[-*]\s+(.*)$/)
    const numbered = line.match(/^\s*\d+\.\s+(.*)$/)
    if (bullet) {
      if (list !== 'ul') {
        closeList()
        html.push('<ul>')
        list = 'ul'
      }
      html.push(`<li>${renderMaintenanceInline(bullet[1])}</li>`)
      return
    }
    if (numbered) {
      if (list !== 'ol') {
        closeList()
        html.push('<ol>')
        list = 'ol'
      }
      html.push(`<li>${renderMaintenanceInline(numbered[1])}</li>`)
      return
    }
    closeList()
    if (line.trim() === '') {
      html.push('<br />')
      return
    }
    html.push(`<p>${renderMaintenanceInline(line)}</p>`)
  })
  closeList()
  return html.join('')
}
